
import { defineComponent } from 'vue';
import config from '@/shared/constants/config';
import { mapGetters, mapState } from 'vuex';
import { GlobalState } from '@/shared/models/GlobalState';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import ShareSiteBox from '@/shared/components/ShareSiteBox.vue';
import { randomIntFromInterval } from '@/utils';
import { urlJoin } from '../helpers/urlJoin';

export default defineComponent({
  name: 'TheHeader',
  components: {
    ResizableImage,
    ShareSiteBox,
  },
  computed: {
    targetLanguageId(): string {
      if (this.languageId === 'sk') return 'en';
      if (this.languageId === 'en') return 'sk';
      return null;
    },
    showDeveloperHeader(): boolean {
      return !this.isEstateAgencyMode;
    },
    showSlogans(): boolean {
      return this.languageId === 'sk' && !this.isEstateAgencyMode;
    },
    baseUrl() {
      var url = config.IS_ESTATE_AGENCY_MODE
        ? urlJoin(window.location.origin, config.FRONT_RELATIVE_URL)
        : urlJoin(window.location.origin, config.FRONT_RELATIVE_APP_URL);
      if (this.languageId == 'sk') {
        return url;
      } else {
        return urlJoin(url, this.languageId);
      }
    },
    isMenuOpened: {
      get() {
        return this.$store.state.isMenuOpened;
      },
      set(value) {
        this.$store.commit('menuOpened', value);
      },
    },
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    ...mapGetters(['isLoggedIn', 'isMobile', 'favoriteCount', 'compareCount', 'kabernetContext']),
  },
  data() {
    return {
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      domain: config.DOMAIN,
      logoUrl: config.BASE_URL + '/img/logo.svg',
      helpUrl: config.BASE_URL + '/pomoc',
      developerUrl: config.BASE_URL + '/developerske-projekty',
      developerIconUrl: config.BASE_URL + '/img/slogans/slogan_developer_icon.png',
      developerImageUrl: config.BASE_URL + '/img/slogans/slogan_developer.png',
      languageId: config.LANGUAGE,
      aboutUsUrl: config.ABOUT_US_URL,
      isLoginModalVisible: false,
      alertText: '',
      sloganUrl: '',
    };
  },
  created() {
    let number = randomIntFromInterval(1, 4);
    if (number < 4) {
      this.sloganUrl = config.BASE_URL + '/img/slogans/slogans-' + number.toString().padStart(2, '0') + '.png?v=1';
    }
  },
  watch: {
    isLoggedIn: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.isLoginModalVisible = false;
      }
    },
  },
  methods: {
    go(event, navigate, isExactActive, alertText) {
      event.preventDefault();
      if (this.isLoggedIn || !alertText) {
        navigate();
        if (isExactActive) {
          this.closeMenu();
        }
      } else {
        this.showLoginModal(alertText);
      }
    },
    changeLanguage(targetLanguageId: string) {
      let baseUrl = urlJoin(window.location.origin, config.FRONT_RELATIVE_URL);
      if (window.location.pathname.startsWith(`/${this.languageId}/`)) {
        let target = urlJoin(baseUrl, targetLanguageId, window.location.pathname.substring(3)) + window.location.search;
        window.location.replace(target);
      } else if (window.location.pathname.startsWith(`/preview/${this.languageId}/`)) {
        let target = urlJoin(baseUrl, targetLanguageId, window.location.pathname.substring('/preview'.length + 3)) + window.location.search;
        window.location.replace(target);
      } else {
        if (targetLanguageId == 'sk') {
          window.location.replace(baseUrl);
        } else {
          let target = urlJoin(baseUrl, targetLanguageId);
          window.location.replace(target);
        }
      }
    },
    headerMenuMouseOver() {
      if (!this.isMobile) {
        this.isMenuOpened = true;
      }
    },
    headerMenuMouseLeave() {
      if (!this.isMobile) {
        this.isMenuOpened = false;
      }
    },
    closeMenu() {
      this.$store.commit('menuOpened', false);
    },
    showLoginModal(alertText: string) {
      this.closeMenu();
      this.alertText = alertText;
      this.isLoginModalVisible = true;
    },
    closeLoginModal() {
      this.closeMenu();
      this.$store.commit('menuOpened', false);
      this.isLoginModalVisible = false;
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router
          .push('/')
          .then(() => {
            window.location.reload();
          })
          .catch(() => {
            window.location.reload();
          });
      });
    },
  },
});
